<script>
import { getCompressedUrl } from "@/utils/common"
import { url_prefix } from "@/utils/uploadFile"
import FileControl from "./FileControl"
import StaffPopover from "@/components/BaseComponents/StaffPopover.vue"
import FilePreview from "@/components/BaseComponents/FilePreview.vue"
import StaffAvatar from "@/components/StaffAvatar"
import Rate from "@/components/BaseComponents/Rate"
import { timeTypeList } from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/static"
import dj from "dayjs"

export default {
  name: "sheet-table-cell",
  components: { FileControl, StaffPopover, StaffAvatar, FilePreview, Rate },
  props: {
    control: Object,
    sheetData: Object,
    fileMap: Object,
    watermark: String,
    from: {
      type: String,
      default: "SheetTable"
    }
  },
  methods: {
    renderUser(user) {
      if (!user) return null
      return (
        <staff-popover staff-id={user.id} placement="top" style="display: inline-block;">
          <div slot="reference" class="user-wrapper flex-center">
            <staff-avatar size="small" user={user}></staff-avatar>
            <span class="name">{user.name}</span>
          </div>
        </staff-popover>
      )
    },
    renderString(str, right = false) {
      return (
        <span class={{ "text-right": right }} v-tip>
          {str}
        </span>
      )
    },
    getFormatTime(control, strVal) {
      let timeFormat = timeTypeList.find(time => time.value === control.timeType).djFormat
      return dj(strVal).format(timeFormat)
    }
  },
  render(h) {
    const { sheetData, control } = this
    if (!sheetData || !control) return null
    const { _cid, _type: type } = control
    if (!_cid) {
      const { value } = control // 特殊字段，例如creator,updateUser,owner等
      return ["creator", "updateUser", "owner"].includes(value)
        ? this.renderUser(sheetData[value])
        : this.renderString(sheetData[value])
    }
    const strVal = sheetData.data[_cid]
    switch (type) {
      case "staff":
        return control.oneFlag
          ? this.renderUser(sheetData.data[_cid + "_o"])
          : this.renderString(strVal)
      case "company":
      case "department":
        return (
          <div>
            {strVal
              ?.split(",")
              .filter(t => t)
              .map((item, idx) => (
                <span key={idx} class="common-wrapper flex-center">
                  <svg-icon icon-class={`field_${type}`}></svg-icon>
                  <span class="name">{item}</span>
                </span>
              ))}
          </div>
        )
      case "ref":
        return control.oneFlag ? (
          <span
            class="ref-wrapper clickable"
            vOn:click_stop={() => this.$emit("open-detail-dialog", sheetData, _cid)}
            v-tip
          >
            {strVal}
          </span>
        ) : (
          this.renderString(strVal, this.from === "SheetTable")
        )
      case "sign": {
        const fileId = sheetData.data[`${_cid}_f`]
        const file = this.fileMap?.[fileId]
        if (!file) return null
        const preview = file => {
          this.$refs.signFilePreview.preview({
            url: url_prefix + file.path,
            type: "img",
            name: file.name
          })
        }
        return (
          <div vOn:click_stop={() => preview(file)}>
            <img src={getCompressedUrl(url_prefix + file.path)} />
            <file-preview ref="signFilePreview"></file-preview>
          </div>
        )
      }
      case "file": {
        const watermark=this.watermark
        const fileIds = sheetData.data[`${_cid}_f`] || []
        const files = fileIds.map(fileId => this.fileMap?.[fileId]).filter(t => t)
        return <file-control {...{ attrs: { strVal, files, control,watermark,sheetData }}} ></file-control>
      }
      case "option": {
        const vals = sheetData.data[`${_cid}_o`]
        if (!vals?.[0]?.color) return this.renderString(strVal)
        return (
          <div>
            {vals.map(({ label, value, color }, index) => (
              <span key={index} class={["option-item", color]}>
                {label}
              </span>
            ))}
          </div>
        )
      }
      case "rate": {
        return <rate {...{ attrs: { value: parseInt(strVal) || 0, control } }} disabled></rate>
      }
      case "check": {
        return (
          <div class="check-info">
            <el-checkbox value={"选中" === strVal} disabled class="check"></el-checkbox>
          </div>
        )
      }
      case "progress": {
        if (strVal)
          return (
            <el-progress
              percentage={parseInt(strVal) >= 0 ? parseInt(strVal) : 0}
              type={control.optionStyle === "条形" ? "line" : "circle"}
              class="progress"
              stroke-width={control.optionStyle === "条形" ? 6 : 10}
            ></el-progress>
          )
        else return this.renderString(strVal)
      }
      case "url": {
        return (
          <el-link underline={false} type="primary" href={strVal} target="_blank">
            {strVal}
          </el-link>
        )
      }
      case "calc":
      case "gather":
      case "money":
      case "number":
        return this.renderString(strVal, true)
      case "time":
        if (!["半年度", "季度"].includes(control.timeType) && strVal)
          return this.renderString(this.getFormatTime(control, strVal))
        else return this.renderString(strVal)
      default:
        return this.renderString(strVal)
    }
  }
}
</script>

<style lang="scss" scoped>
.flex-center {
  display: flex;
  align-items: center;
  .name {
    margin-left: 5px;
    color: #303133;
    flex: 1;
    white-space: nowrap;
  }
}
.common-wrapper {
  line-height: 22px;
  display: inline-flex;
  background-color: #eaecf0;
  padding: 2px 4px;
  border-radius: 4px;
  margin-right: 2px;
}
.user-wrapper {
  line-height: 22px;
  background-color: #eaecf0;
  padding: 2px 4px;
  border-radius: 15px;
  ::v-deep {
    .el-avatar--small {
      width: 20px;
      height: 20px;
      line-height: 20px;
      font-size: 10px;
    }
  }
}
.ref-wrapper {
  width: unset !important;
  max-width: 100% !important;
  flex: 0 0 auto !important;
  color: $color-main;
  font-weight: normal;
  cursor: pointer;
}
.text-right {
  text-align: right;
}
.check-info {
  text-align: center;
  .check {
    ::v-deep {
      .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
        background-color: #409eff;
        border-color: #409eff;
      }
      .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
        border-color: #fff;
      }
      .el-checkbox__input.is-disabled .el-checkbox__inner {
        border-color: #dcdfe6;
        background-color: #fff;
      }
    }
  }
}
.option-item {
  line-height: 22px;
  display: inline-block;
  padding: 0 6px;
  border-radius: 6px;
  color: white;
  margin-right: 5px;
  white-space: nowrap;
}

.progress {
  display: flex;
  align-items: center;
  width: 100%;
  ::v-deep {
    .el-progress-bar {
      flex: 1;
    }
    .el-progress-circle {
      width: 36px !important;
      height: 36px !important;
    }
    .el-progress__text {
      font-size: 12px !important;
      color: #303133 !important;
    }
  }
}
.el-progress--circle {
  width: 36px;
}
</style>
